// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"83c768dc","703":"bb7bbc28"}[chunkId] + ".chunk.js";
};